import { bonzai, type InferBonzai } from "bonzai"
import * as api from "./endpoints"
import { apiMock } from "./mock"
export { apiMock } from "./mock"

const apiV3 = import.meta.env.MODE === "test" ? apiMock.mocks : api

export type leaderboard = InferBonzai<typeof leaderboard>
export const leaderboard = bonzai(apiV3)
